var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("We will ask you for a copy of your assets and liabilities while processing your application")])
}
var staticRenderFns = []

export { render, staticRenderFns }